export enum QueueConditionOperation {
    "EQUALS" = "EQUALS",
    "CONTAINS" = "CONTAINS"
}